import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import {
  FaCalendarAlt,
  FaCreditCard,
  FaDollarSign,
  FaRegCheckCircle,
  FaUser,
} from "react-icons/fa";
import { TbHandClick } from "react-icons/tb";
import {
  formatToIndianNumber,
  toInitials,
  useIsMobile,
} from "../../../utilities";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { FaKey } from "react-icons/fa";
import { BsBank2 } from "react-icons/bs";
import { FaRegCreditCard } from "react-icons/fa";
import { FaAddressCard } from "react-icons/fa";
import { IoCardSharp } from "react-icons/io5";
import { FaPhoneAlt } from "react-icons/fa";
import { Form, Offcanvas, Table } from "react-bootstrap";

const mappEdKey = {
  customer_referral: "Customer Referral",
  employee_referral: "Employee Referral",
  other: "Other",
  fuel_allowance: "Fuel Allowance",
  fuel_deduction: "Fuel Deduction",
  leave: "Leave",
  penalty: "Penalty",
  advance_deduction: "Advance Deduction",
  other_deduction: "Other",
};

const EmployeePayrollDetails = ({ show, handleClose, clickEmployee }) => {
  const isMobile = useIsMobile();
  const [tab, setTab] = useState("salary");
  useEffect(() => {
    if (show) {
      setTab("salary");
    }
  }, [show]);
  const tabs = [
    {
      name: "Salary",
      icons: <FaDollarSign size={12} />,
      path: "salary",
    },
    {
      name: "Attendance",
      icons: <FaCalendarAlt size={12} />,
      path: "attendance",
    },
    {
      name: "Employee",
      icons: <FaUser size={12} />,
      path: "employee",
    },
  ];
  if (!clickEmployee) return null;

  const { employee, payroll_snapshot, attendance_summary } = clickEmployee;

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      style={{ width: isMobile ? "100vw" : "500px" }}
    >
      <Offcanvas.Header
        closeButton
        className="d-flex align-items-center p-0 pt-2 ps-2 pe-4 border-bottom bg-lighter"
      >
        <ul className="nav custom-sidebar-nav gap-2">
          {tabs.map((item) => (
            <li className="nav-item" key={item.path}>
              <span
                onClick={() => setTab(item.path)}
                className={`nav-link  ${item.path == tab ? "active" : ""}`}
                style={{ fontSize: "0.85rem" }}
              >
                {item.icons}
                {item.name}
              </span>
            </li>
          ))}
        </ul>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {tab == "salary" ? (
          <div className="mb-3">
            <div className="bg-lighter rounded-3 p-3 mb-4">
              <h5 className="mb-1 text-darker">Allowances :</h5>
              <div className="">
                {Object.entries(
                  payroll_snapshot?.allowances_breakdown || {}
                ).map(([k, v], index, arr) => (
                  <div
                    key={k}
                    className={`d-flex justify-content-between py-1 ${
                      index !== arr.length - 1 ? "border-bottom" : ""
                    }`}
                  >
                    <span
                      className="text-dark fw-medium"
                      style={{ fontSize: "0.9rem" }}
                    >
                      {mappEdKey[k]}
                    </span>
                    <span className="fw-medium text-darker">₹{v}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-lighter rounded-3 p-3">
              <h5 className="mb-1 text-darker">Deductions :</h5>
              <div className="">
                {Object.entries(
                  payroll_snapshot?.deductions_breakdown || {}
                ).map(([k, v], index, arr) => (
                  <div
                    key={k}
                    className={`d-flex justify-content-between py-1 ${
                      index !== arr.length - 1 ? "border-bottom" : ""
                    }`}
                  >
                    <span
                      className="text-dark fw-medium"
                      style={{ fontSize: "0.9rem" }}
                    >
                      {mappEdKey[k]}
                    </span>
                    <span className="fw-medium text-danger">₹{v}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Totals */}
            <div className="mt-3 bg-lighter p-2 rounded-3">
              <div className="d-flex justify-content-between mb-2">
                <span className="fw-medium text-dark">Gross Pay</span>
                <span className="fw-bold text-darker">
                  ₹{payroll_snapshot?.gross_pay}
                </span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="fw-medium text-dark">Total Deductions</span>
                <span className="fw-bold text-danger">
                  -₹{payroll_snapshot?.total_deductions}
                </span>
              </div>
              <div className="border-top pt-3 d-flex justify-content-between mb-0">
                <span className="text-dark fw-medium">Net Pay</span>
                <span className="text-darker fw-semibold">
                  ₹{payroll_snapshot?.net_pay}
                </span>
              </div>
            </div>
          </div>
        ) : tab == "attendance" ? (
          <div className="card rounded-3 overflow-hidden">
            <div className="p-2 border-bottom bg-lighter">
              <h5 className="m-0">Attendance Summary</h5>
            </div>
            <div className="card-body">
              <div className="d-flex flex-column gap-3">
                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Total Days</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.total_days_in_month || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-primary"
                      role="progressbar"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Working Days</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.working_days || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.working_days || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Holidays</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.holidays || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-info"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.holidays || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Leaves</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.earned_leaves || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-warning"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.earned_leaves || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Paid Leaves</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.paid_leaves || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.paid_leaves || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Unpaid Leaves</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.unpaid_leaves || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-danger"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.unpaid_leaves || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>

                <div>
                  <div
                    className="d-flex justify-content-between mb-1"
                    style={{ fontSize: "0.9rem" }}
                  >
                    <span className="fw-medium text-dark">Late Coming</span>
                    <span className="fw-medium text-darker">
                      {attendance_summary?.late_comings || 0}
                    </span>
                  </div>
                  <div className="progress" style={{ height: "6px" }}>
                    <div
                      className="progress-bar bg-secondary"
                      role="progressbar"
                      style={{
                        width: `${
                          ((attendance_summary?.late_comings || 0) /
                            (attendance_summary?.total_days_in_month || 1)) *
                          100
                        }%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : tab == "employee" ? (
          <div className="card overflow-hidden rounded-3">
            <div className="bg-lighter p-2">
              <div className="d-flex gap-2">
                <div
                  className="rounded-circle bg-dark text-white d-flex justify-content-center align-items-center overflow-hidden"
                  style={{
                    width: "40px",
                    height: "40px",
                    fontWeight: 500,
                    fontSize: "1rem",
                  }}
                >
                  <span>{toInitials(employee?.name || "")}</span>
                </div>
                <div>
                  <h5 className="mb-0">{employee?.name || "Employee Name"}</h5>
                  <small className="text-dark">
                    {employee?.designation || "Designation"} •{" "}
                    {employee?.apartment_type || "-"}
                  </small>
                </div>
              </div>
            </div>
            {/* Body */}
            <div className="card-body">
              <div>
                <h6
                  className="text-uppercase m-0 mb-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Contact :
                </h6>
                <div className="d-flex flex-column gap-1">
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <FaPhoneAlt className="me-1" size={13} /> Mobile
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.mobile_number || "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <FaAddressCard className="me-1" size={13} /> Aadhaar
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.adhar_no || "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <IoCardSharp className="me-1" size={13} /> PAN
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.pan_no || "-"}
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                <h6
                  className="text-uppercase m-0 mb-2"
                  style={{ fontSize: "0.8rem" }}
                >
                  Bank Details:
                </h6>
                <div className="d-flex flex-column gap-1">
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <BsBank2 className="me-1" size={13} /> Bank
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.bank_name || "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <FaCreditCard className="me-1" size={13} /> Account
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.bank_account_number || "-"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span className="fw-medium text-dark">
                      <FaKey className="me-1" size={13} /> IFSC
                    </span>
                    <span className="fw-medium text-darker">
                      {employee?.bank_ifsc || "-"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>Nothing Selected</div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

const DoorStepEmployeeSalaryTable = ({
  employees,
  setEmployees,
  onPayEmployee,
  selectedEmployees,
  onSelectEmployee,
  onSelectAll,
}) => {
  const isMobile = useIsMobile();
  const [clickEmployee, setClickEmployee] = useState(null);
  const [offcanvasShow, setOffcanvasShow] = useState(false);

  const handleOffCanvasOpen = (employee) => {
    setClickEmployee(employee);
    setOffcanvasShow(true);
  };

  const handleOffCanvasClose = () => {
    // setClickEmployee(null);
    setOffcanvasShow(false);
  };

  const pendingEmployees = employees.filter(
    (emp) => emp?.payroll_snapshot?.payment_status?.toLowerCase() === "pending"
  );
  const allPendingSelected =
    pendingEmployees?.length > 0 &&
    pendingEmployees.every((emp) =>
      selectedEmployees?.some((item) => item?.employee?.id == emp?.employee?.id)
    );

  return (
    <>
      <div className="table-responsive">
        <table className="table align-middle fs-6 mb-0">
          <thead className="table-light custom-thead">
            <tr>
              <th style={{ width: "40px" }}>
                <Form.Check
                  type="checkbox"
                  checked={allPendingSelected}
                  onChange={(e) => onSelectAll(e.target.checked)}
                  disabled={pendingEmployees.length === 0}
                />
              </th>
              <th style={{ minWidth: "150px" }}>Employee</th>
              <th>Attendance</th>
              <th>Earning</th>
              <th>Allowance</th>
              <th>Deduction</th>
              <th>Gross Salary</th>
              <th>Net Salary</th>
              <th>Payment Date</th>
              <th className="text-end" style={{ minWidth: "120px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {employees.map((employee) => (
              <tr key={employee.id}>
                <td>
                  <div className="d-flex gap-2 align-items-center">
                    <Form.Check
                      type="checkbox"
                      checked={selectedEmployees.some(
                        (item) => item?.employee?.id == employee?.employee?.id
                      )}
                      onChange={(e) => onSelectEmployee(employee)}
                      disabled={
                        employee?.payroll_snapshot?.payment_status?.toLowerCase() ===
                        "paid"
                      }
                    />
                    <button
                      className="btn btn-outline-light rounded-2"
                      style={{ padding: "0.2rem" }}
                      onClick={(e) => {
                        handleOffCanvasOpen(employee);
                      }}
                      title="View Details"
                    >
                      <MdOutlineKeyboardDoubleArrowLeft className="text-darker" />
                    </button>
                  </div>
                </td>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="rounded-circle bg-light text-dark d-flex justify-content-center align-items-center overflow-hidden"
                      style={{
                        width: "38px",
                        height: "38px",
                        fontWeight: 500,
                        fontSize: "0.9rem",
                      }}
                    >
                      <span>{toInitials(employee?.employee?.name)}</span>
                    </div>
                    <div>
                      <Link className="text-uppercase text-primary fw-bold d-block">
                        {employee?.employee?.name}
                      </Link>
                      <Link className="small text-secondary d-block">
                        {employee?.employee?.mobile_number || "-"}
                      </Link>
                    </div>
                  </div>
                </td>
                <td>
                  {employee?.attendance_summary?.working_days}/
                  {employee?.attendance_summary?.total_days_in_month} days
                </td>
                <td className="fw-semibold">
                  ₹
                  {formatToIndianNumber(
                    employee?.payroll_snapshot?.earned_gross
                  )}
                </td>
                <td className="fw-semibold">
                  ₹
                  {formatToIndianNumber(
                    employee?.payroll_snapshot?.total_allowances
                  )}
                </td>
                <td className="fw-semibold">
                  ₹
                  {formatToIndianNumber(
                    employee?.payroll_snapshot?.total_deductions
                  )}
                </td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(employee?.payroll_snapshot?.gross_pay)}
                </td>
                <td className="fw-semibold">
                  ₹{formatToIndianNumber(employee?.payroll_snapshot?.net_pay)}
                </td>
                <td>
                  {employee?.payment_date ? (
                    <div>{format(employee?.payment_date, "dd MMM yyyy")}</div>
                  ) : (
                    <span className="text-dark">Not paid</span>
                  )}
                </td>
                <td className="text-end">
                  {employee?.payroll_snapshot?.payment_status?.toLowerCase() ===
                    "pending" ||
                  employee?.payroll_snapshot?.payment_status?.toLowerCase() ===
                    "unpaid" ? (
                    <span
                      className="btn btn-sm btn-outline-primary rounded-pill"
                      onClick={() => onPayEmployee(employee)}
                      style={{ padding: "0rem 0.5rem" }}
                    >
                      <TbHandClick className="me-1" />
                      Pay Now
                    </span>
                  ) : (
                    <span className="badge text-bg-success-soft rounded-pill">
                      <FaRegCheckCircle className="me-1" />
                      Completed
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {employees.length === 0 && (
          <div className="text-center py-5 text-muted">
            No employees found matching your criteria.
          </div>
        )}
      </div>
      <EmployeePayrollDetails
        show={offcanvasShow}
        handleClose={handleOffCanvasClose}
        clickEmployee={clickEmployee}
      />
    </>
  );
};

export default DoorStepEmployeeSalaryTable;
